var CasePracticeTsComponent = (function () {
    function CasePracticeTsComponent() {
    }
    CasePracticeTsComponent.prototype.ngOnInit = function () {
    };
    return CasePracticeTsComponent;
}());
export { CasePracticeTsComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-ts/case-practice-ts.component.ts.pre-build-optimizer.js